<template>
	<div class="hexiao">
		<van-nav-bar
			title=""
			left-text="返回"
			left-arrow
			@click-left="onClickLeft"
		/>

		<div class="main">
			<div class="header">
				核销申报
			</div>
			<div class="sys-img">
				<img src="../../assets/images/scan.png" mode=""/>
			</div>
			<div class="btn" @click="scan">
				<img src="../../assets/images/btn.png"/>
				<div class="commit-text">点击扫码</div>
			</div>

			<div class="history" @click="toHxList" >
				<div class="txt">
					核销记录
				</div>
				<div class="jt">
					<img src="../../assets/images/jt@2x.png" mode=""/>
					<img src="../../assets/images/jt@2x.png" mode=""/>
				</div>
			</div>
		</div>

	</div>
</template>

<script>
import mix1 from "@/mixins/page";
import wxShare from "@/utils/wxShare";


import {
  NavBar 
} from "vant";




//前端实现签名
// import jsSHA from 'jssha';
	export default {
		mixins: [mix1],
  		name: "Hexiao",
		components: {
			[NavBar.name]: NavBar
      	},
	  
		data() {
			return {
				// appid:"wx13efbea78e14d15c",// 对方小程序id
				// appsecret:"bf2c672858be4f2a55adb254a528593e",//对方小程序秘钥
				accessToken:"",
				ticket:"",
			}
		},
		created() {
			// this.getWxShareInfo();
			// this.getAccessToken();
			// this.getJsapiTicket();
		},
		methods: {

			onClickLeft(){
				this.$router.go(-1);
			},
		async getAccessToken(){
				// 获取accessToken
				let tokenUrl = 'https://api.weixin.qq.com/cgi-bin/token?grant_type=client_credential&appid='+this.appid  +'&secret=' + this.appsecret
				console.log("tokenUrl",tokenUrl);

				// let data = {};
				// data.url = tokenUrl;
				// const promise = this.apiGet(data)
				// try {
				// 	apiResult = await promise;
				// } catch (ex) {
				// 	console.log("ex：",ex);
				// }
				// console.log("getAccessToken",promise);
				// this.accessToken = apiResult.obj.access_token
			},
			async getJsapiTicket(){
				// 获取jsapiTicket
				let ticketUrl = '/ticket/getticket?type=jsapi&access_token=' + this.accessToken
				const promise = this.apiGet(ticketUrl)
				try {
					apiResult = await promise;
				} catch (ex) {
					console.log("ex：",ex);
				}
				console.log("jsapiTicket",promise);
				// this.ticket = apiResult.obj.ticket;
			},
			toHxList(){
				this.$router.push("/ercode/hexiaoList")
			},
			async getWxShareInfo() {
					const promise = this.apiGet("fx.jsapi", {
					jsapiUrl: window.location.href
				});
					let apiResult = null;
				try {
					apiResult = await promise;
				} catch (ex) {
					apiResult = null;
				}
				if (this.hasException(apiResult)) {
					return;
				}

				const data = {
					debug: true, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
					appId: apiResult.obj.appId, // 必填，公众号的唯一标识
					timestamp: apiResult.obj.timestamp, // 必填，生成签名的时间戳
					nonceStr: apiResult.obj.noncestr, // 必填，生成签名的随机串
					signature: apiResult.obj.signature // 必填，签名
					// jsApiList: "jsApiList", // 必填，需要使用的JS接口列表
				};

				const dataForWeixin = {
					title: "大狮汇",
					desc: "大狮汇-中国最大的企业家户外社交活动报名平台",
					link: window.location.href,
					imgUrl:
					"http://cdn.meiguonet.com/zhongchuang/pq/dp/ahkuwjkkdkmvadlwsglperwrdpgumxcr.jpg"
				};

				wxShare.getJSSDK(data, dataForWeixin);
				// this.del = apiResult.obj
			},
			scan(){	
				// alert("当前已调用H5 wx.scanQRCode方法，需要相关微信配置才生效;如不使用H5实现扫码，需要小程序添加一个扫码页面")

				this.$router.push('/ercode/test')
				// wx.scanQRCode({
				// 	needResult: 1,// 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
				// 	scanType: ["qrCode","barCode"],// 可以指定扫二维码还是一维码，默认二者都有
				// 	success: function (res) {
				// 	// 当needResult 为 1 时，扫码返回的结果
				// 	alert("扫描成功", res.resultStr);
				// 	},
				// 	fail : function(res) {
				// 	console.log('扫描失败!'+res.errMsg);
				// 	}
				// });

				// wxShare.scanQRCode({
				// 	needResult: 1,// 默认为0，扫描结果由微信处理，1则直接返回扫描结果，
				// 	scanType: ["qrCode","barCode"],// 可以指定扫二维码还是一维码，默认二者都有
				// 	success: function (res) {
				// 	// 当needResult 为 1 时，扫码返回的结果
				// 	alert("扫描成功", res.resultStr);
				// 	},
				// 	fail : function(res) {
				// 	console.log('扫描失败!'+res.errMsg);
				// 	}
				// });
			}
			              
		}
	}
</script>

<style lang="less">
	.hexiao{
		.main{
			margin-top: 13px;
			width: 750px;
			height: 1483px;
			background: #FFFFFF;
			border-radius: 0px 0px 0px 0px;
			position: relative;
			.header{
				// font-size: 40px;
				position: absolute;
				top: 235px;
				left: 50%;
				transform: translateX(-50%);
				width: 200px;
				height: 56px;
				font-family: PingFang SC, PingFang SC;
				font-weight: bold;
				font-size: 20px;
				color: #000000;
				line-height: 56px;
				text-align: center;
				font-style: normal;
				text-transform: none;
			}
			.sys-img{
				position: absolute;
				top: 402px;
				left: 50%;
				transform: translateX(-50%);
				width: 178px;
				height: 163px;
				img{
					display: block;
					width: 178px;
					height: 163px;
				}
			}
			.btn{
				position: absolute;
				width: 424px;
				height: 88px;
				top: 677px;
				left: 163px;
				img{
					display: block;
					width: 424px;
					height: 88px;
				}
				.commit-text{
				   font-size: 16px;
					color: #FFFFFF;
					position: absolute;
					left: 50%;
					top: 50%;
					transform: translate(-50%,-50%);
					z-index: 999;
				}
			}
			.history{
				position: absolute;
				top:1200px;
				left:294px;
				width:200px;
				height: 48px;
				display: flex;
				align-items: center;
				justify-content: center;
				.txt{
					// width: 160px;
					height: 46px;
					font-family: PingFang SC, PingFang SC;
					font-weight: 400;
					font-size: 12px;
					color: #FF0B0B;
					line-height: 46px;
					text-align: left;
					font-style: normal;
					text-transform: none;
					text-align: center;
					vertical-align: middle;
				}
				.jt{
					display: flex;
					img{
						display:block;
						width: 12px;
						height: 12px;
						margin-left: 10px;
					}
				}

			}
		}
	}
</style>

